/**
 * Generated runtime TestId mirror for frontend/src/pages/analytics/EffectiveAccessByIdentity.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const EffectiveAccessByIdentityTestIds = {
  colActions: "col-actions",
  colIdentity: "col-identity",
  colParty: "col-party",
  colStatus: "col-status",
  colType: "col-type",
  effectiveAccessByIdentityPage: "effective-access-by-identity-page",
  btnViewAccess: (identity_id: string) => `btn-view-access-${identity_id}`,
  btnViewAccessPrefix: () => "btn-view-access-" as TestIdPrefix,
  linkIdentity: (identity_id: string) => `link-identity-${identity_id}`,
  linkIdentityPrefix: () => "link-identity-" as TestIdPrefix
} as const;
